import { useMutation } from 'react-query';
import axios from '../utils/axios-util';

const fetchGISNodes = async (customerName, data) => {
  const response = await axios({
    url: '/gis/' + customerName,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  });
  return response.data;
};

const useGISNodes = (customerName) => {
  return useMutation((data) => fetchGISNodes(customerName, data));
};

export default useGISNodes;
